export const apiQueries = {
    clientArchitectFilter: 'clientTypes=3',
};
